import { createFileRoute } from "@tanstack/react-router"
import { TeamsSettingsPage } from "~/components/settings/TeamsSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/teams")({
  component: TeamsSettingsPage,
})
